import { splitProps } from 'solid-js'

type Props = ComponentProps<'main'>

export function Main(props: Props) {
  return <Presenter {...props} />
}

function Presenter(props: Props) {
  const [component, attributes] = splitProps(props, ['children'])
  return <main {...attributes}>{component.children}</main>
}
